import { usePermissionsCheck, useUserSession } from '@speeki/client-admin';

export const useUserModules = () => {
    const { data: userData, loading: userLoading } = useUserSession();
    const { permissionsCheck } = usePermissionsCheck();

    const hasFrameworksAccess = permissionsCheck(['FRAMEWORKS_DASHBOARD']);
    const hasIncidentsAccess =
        !!userData?.user.tenant?.modules.cases &&
        permissionsCheck(['DASHBOARD']);
    const hasEsgAccess =
        !!userData?.user.tenant?.modules.esg &&
        permissionsCheck(['ESG_DASHBOARD', 'ESG_QUESTIONNAIRE'], true);
    const hasSurveyAccess =
        !!userData?.user.tenant?.modules.surveys &&
        permissionsCheck(['SURVEYS_DASHBOARD']);
    const hasDisclosureAccess =
        !!userData?.user.tenant?.modules.disclosures &&
        permissionsCheck(['DISCLOSURES_DASHBOARD']);
    const hasMetricsAccess = permissionsCheck(['METRICS_MANAGEMENT']);
    const hasTasksManagerAccess = permissionsCheck(
        ['TASKS_DASHBOARD', 'TASKS_ASSIGNEE', 'TASKS_ASSIGNOR'],
        true,
    );

    const hasReportingAccess = permissionsCheck(['ESG_REPORTING']);

    return {
        hasAllAccess:
            hasIncidentsAccess &&
            hasEsgAccess &&
            hasSurveyAccess &&
            hasDisclosureAccess &&
            hasReportingAccess &&
            hasMetricsAccess &&
            hasTasksManagerAccess,
        hasDisclosureAccess,
        hasEsgAccess,
        hasFrameworksAccess,
        hasIncidentsAccess,
        hasMetricsAccess,
        hasNoAccess:
            !hasIncidentsAccess &&
            !hasEsgAccess &&
            !hasSurveyAccess &&
            !hasDisclosureAccess &&
            !hasReportingAccess &&
            !hasMetricsAccess &&
            !hasTasksManagerAccess,
        hasNoQuickActionsAccess:
            !hasEsgAccess &&
            !hasReportingAccess &&
            !hasIncidentsAccess &&
            !hasSurveyAccess &&
            !hasDisclosureAccess,
        hasReportingAccess,
        hasSurveyAccess,
        hasTasksManagerAccess,
        userLoading,
    };
};
